import BrandLoader from './loaders/BrandLoader';

// Full-page branded loader — used for route guards (RequireDistrict / RequireAdmin)
// and Suspense fallback on lazy-loaded routes.
export default function AppLoader() {
  return <BrandLoader />;
}
